export default "__VITE_ASSET__5fde35b1__"